import { useMutation } from '@tanstack/react-query'
import { WaitlistNotificationParams } from 'shared/schemas/resend'
import { toast } from 'sonner'
import { internal_backend } from '~/internal-backend'

export const useSendWaitlistNotification = () =>
  useMutation({
    mutationKey: ['send-waitlist-notification'] as const,
    mutationFn: async (params: WaitlistNotificationParams) => {
      const result = await internal_backend.send_waitlist_notification.request(params)
      if (result.error) {
        toast.error('Failed to send waitlist notification email')
        throw new Error(result.error?.message ?? 'Email send failed')
      }
      return result
    },
    onSuccess: () => toast.success('Waitlist notification sent successfully'),
  })
